import { Box, Button, Skeleton, Stack } from '@mui/material'
import { WatchPartyBanner } from 'app/_components'
import { GetHomeScreensQuery, GetRecommendationRowListQuery } from '~/__generated__/graphql'
import { KeyVisualsCarousel } from '~/components/KeyVisualsCarousel'
import { KeyVisualModel } from '~/features/popup/hooks/createModel'
import { DefaultCardGroup } from '~/features/video/components/CardGroup'
import { Colors } from '~/libs/mui/color'
import { RecommendationRow } from './RecommendationRow'

const INITIAL_FETCH_ROW_COUNT = 3

interface HomePageProps {
  keyVisuals: KeyVisualModel[]
  homeScreens: GetHomeScreensQuery['homeScreens']
  recommendationRowList?: GetRecommendationRowListQuery['recommendationRowList']
  onClickDisplayAll: (subCategoryId: number) => void
  /** ビデオカードをクリック */
  onClickVideoItem: (videoId: number) => void
  /** キービジュアルをクリック */
  onClickKeyVisual: (keyVisual: KeyVisualModel) => void
  onKeyVisualShown: (keyVisual: KeyVisualModel) => void
}

export const HomePageContent = ({
  keyVisuals,
  homeScreens,
  recommendationRowList,
  onClickDisplayAll,
  onClickVideoItem,
  onClickKeyVisual,
  onKeyVisualShown,
}: HomePageProps) => {
  return (
    <Box>
      <Box sx={{ position: 'relative' }}>
        <KeyVisualsCarousel
          keyVisuals={keyVisuals}
          onClickThumbnail={onClickKeyVisual}
          onSlideShown={onKeyVisualShown}
        />
        <WatchPartyBanner overlay />
      </Box>
      <Stack sx={{ paddingX: { xs: 2, sm: 4 }, paddingY: 2 }} spacing={{ xs: 3, sm: 4 }}>
        {(homeScreens.length === 0 || recommendationRowList === undefined) &&
          [1, 2, 3].map((key) => (
            <Stack spacing={1} key={key}>
              <Box display='flex' justifyContent={{ sm: 'flex-start' }} gap={{ xs: 0, sm: 1 }}>
                <Box display='flex' gap={1} alignItems='center'>
                  <Box width='4px' height='18px' bgcolor={Colors.yellow}></Box>
                  <Skeleton variant='text' width={160} sx={{ fontSize: { xs: 17, sm: 18 } }} />
                </Box>
                <Button sx={{ minHeight: 0 }}>　</Button>
              </Box>
              <DefaultCardGroup videos={undefined} onClickVideoItem={() => {}} />
            </Stack>
          ))}
        {recommendationRowList &&
          recommendationRowList.recommendationRows.map((row, index) => (
            <Box key={row.id}>
              <RecommendationRow
                data={row}
                recommendationSessionKey={recommendationRowList.recommendationSessionKey}
                onClickDisplayAll={
                  row.categoryId != null
                    ? () => onClickDisplayAll(Number(row.categoryId))
                    : undefined
                }
                onClickVideoItem={onClickVideoItem}
                deferUntilVisible={index >= INITIAL_FETCH_ROW_COUNT}
              />
            </Box>
          ))}
      </Stack>
    </Box>
  )
}
